import { useState, useRef, useCallback } from 'react';

export function useStatusMessage() {
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState('success');
  const timerRef = useRef(null);

  const showStatus = useCallback((message, type = 'success') => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setStatusType(type);
    setStatusMessage(message);
    timerRef.current = setTimeout(() => setStatusMessage(''), 4000);
  }, []);

  return { statusMessage, statusType, showStatus };
}
